/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

import { PreviewComponentAssets } from '../../../core/usecases';

const ChannelAiringInfo: FunctionComponent<{
    channelNumber?: string;
    callSign?: string;
    videoResolution?: string;
    isThreeD?: boolean;
    isPpv?: boolean;
}> = ({ channelNumber, callSign, videoResolution, isThreeD, isPpv }) => {
    // <channel number> <format icon> <call sign> <ppv icon>

    const oPreviewAssets = new PreviewComponentAssets();

    let formatIconUrl = '';
    if (isThreeD) {
        formatIconUrl = oPreviewAssets.getImageAssetUrlById(
            PreviewComponentAssets.ImageAssets.THREE_D_ICON,
        );
    }
    if (!isThreeD && videoResolution) {
        formatIconUrl = oPreviewAssets.getImageAssetUrlById(
            `${videoResolution.toLocaleUpperCase()}_ICON`,
        );
    }

    let ppvIconUrl = '';
    if (isPpv) {
        ppvIconUrl = oPreviewAssets.getImageAssetUrlById(
            PreviewComponentAssets.ImageAssets.PPV_ICON,
        );
    }

    return (
        <React.Fragment>
            <div className="uikit channel-airing-info primary-text-style muted-color">
                {channelNumber} {formatIconUrl ? <img src={formatIconUrl} /> : null} {callSign}{' '}
                {ppvIconUrl ? <img src={ppvIconUrl} /> : null}
            </div>
        </React.Fragment>
    );
};

export default ChannelAiringInfo;
